import type { HTMLAttributes } from 'react';

import { cn } from '../lib/cn.js';
import { badgeVariants, type BadgeVariantProps } from './badge-variants.js';

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & BadgeVariantProps;

export const Badge = ({ className, variant, ...props }: BadgeProps): React.JSX.Element => (
  <span className={cn(badgeVariants({ variant }), className)} {...props} />
);
